import React from 'react';
import { User } from 'models/User';
import styles from '../styles.module.scss';
import { Button, HasAccess } from 'components';
import { Col, Row, Typography } from 'components';
import { PERMISSIONS } from 'constants/permissions';
import { EditIconButton } from 'components/common/icons';

interface IAssignment {
  isFinalStatus: boolean;
  assignmentData: {
    role: string;
    data: User;
  }[];
  onUpdateAssignmentClick: () => void;
}

export const Assignment = React.memo<IAssignment>(({ assignmentData, onUpdateAssignmentClick, isFinalStatus }) => {
  return (
    <HasAccess role={PERMISSIONS.leads.assignment.read}>
      <Col span={24}>
        <Row justify={'space-between'}>
          <Col>
            <Typography.Text className={styles.title}>Assignments</Typography.Text>
          </Col>
          <Col>
            <HasAccess role={PERMISSIONS.leads.assignment.write}>
              {isFinalStatus ? (
                ''
              ) : (
                <Button type={'link'} icon={<EditIconButton />} onClick={onUpdateAssignmentClick} />
              )}
            </HasAccess>
          </Col>
        </Row>
        <Row gutter={[0, 12]} className={'margin-t-12'}>
          {assignmentData.map(({ role, data }) => (
            <Col span={24} key={role}>
              <Row gutter={[12, 12]} justify={'space-between'} wrap={false}>
                <Col flex="none">
                  <Typography.Text ellipsis={{ tooltip: true }} className={'font-size-14'} type={'secondary'}>
                    {role}
                  </Typography.Text>
                </Col>
                <Col flex="auto" style={{ textAlign: 'right' }}>
                  <Typography.Text ellipsis={{ tooltip: true }} className={'font-size-14'} type={'secondary'}>
                    {data?.firstName ? `${data?.firstName} ${data?.lastName}` : 'Not Set'}
                  </Typography.Text>
                </Col>
              </Row>
            </Col>
          ))}
        </Row>
      </Col>
    </HasAccess>
  );
});
